import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledCardAwardBadge = styled.div`
  .award-image {
    width: ${toRem(176)};
    height: ${toRem(49)};
    margin: ${toRem(24)} auto;
    display: flex;
  }
`;
